import { Questions } from "../types/questions";
import { ATLAS, ATLASCROSSPORT, TAOS, TIGUAN } from "./models";

const questions : Questions = {
    personality : [
        {
            key : 'upFoAnything',
            models: [TAOS]
        },
        {
            key : 'dressedToImpress',
            models: [TIGUAN]
        },
        {
            key : 'liveForTheRush',
            models: [TIGUAN]
        },
        {
            key : 'makeAStatement',
            models: [ATLASCROSSPORT]
        },
        {
            key: 'moreMerrier',
            models: [ATLAS]
        }
    ],

    priority : [
        {
            key : 'drivingToBeFun',
            models : [TAOS]
        },
        {
            key : 'impressesNeighbours',
            models : [TIGUAN, ATLASCROSSPORT]
        },
        {
            key : 'lessTime',
            models : [TAOS]
        },
        {
            key : 'roomForKids',
            models : [ATLAS, ATLASCROSSPORT]
        },
        {
            key : 'perfectCityDogParks',
            models : [TAOS, TIGUAN]
        }
    ],

    typical : [
        {
            key: 'dailyCommute',
            models: [TAOS]
        },
        {
            key: 'outdoorAdventures',
            models: [ATLAS, ATLASCROSSPORT, TAOS]
        },
        {
            key: 'roadTrips',
            models: [ATLAS, TIGUAN]
        },
        {
            key: 'weeklyFamilyOuting',
            models: [TAOS, TIGUAN]
        }
    ],

    seating : [
        {
            key : 'meAndOther',
            models: [TAOS]
        },
        {
            key : 'wholeFamily',
            models: [TIGUAN, ATLASCROSSPORT, TAOS]
        },
        {
            key : 'asManyCanFit',
            models: [ATLAS]
        }
    ],

    budget : [
        {
            key : 'price35000',
            models : [TAOS]
        },
        {
            key : 'price50000',
            models: [TIGUAN]
        },
        {
            key : 'price50000plus',
            models : [ATLAS, ATLASCROSSPORT]
        }
    ]
};

export default questions;